<app-dialog
  class="error-details-dialog"
  headerIcon="assets/cloud-automation-designer/icons/error2.svg"
  headerText="Error"
  cancelText="Close"
  [showTopCancelButton]="false"
  [showSaveButton]="false"
  (cancel)="onClose()"
  [body]="body"
>
  <ng-template #body>
    @if (!loading) {
      <div class="container">
        <div class="general-error-msg">{{ generalErrorMsg }}</div>
        @if (viewDetailsTextVisible) {
          <span
            href="#"
            class="view-error-details link-color"
            (click)="viewErrorDetails()"
            >View Details</span
          >
        }
        @if (showMoreDetails) {
          <span
            href="#"
            class="view-error-details link-color"
            (click)="hideErrorDetails()"
            >Hide Details</span
          >
        }
        @if (showMoreDetails) {
          <div class="more-details-container">
            <span>{{ errorMsgMoreDetails }}</span>
          </div>
        }
      </div>
    }
  </ng-template>
</app-dialog>
